<div class="row">
    <div class="col-12">
      <div class="content-header">Discount Form</div>
    </div>
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- <div class="card-header">
                      <h4 class="card-title">Basic</h4>
                  </div> -->
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <form [formGroup]="discountForm">
                    <fieldset class="form-group">
                      <label for="name"> Name</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="name"
                        id="name"
                        placeholder="Enter Name"
                        [ngClass]="{
                          'is-invalid':
                            discountFormSubmitted && rf.name.invalid,
                          'is-valid':
                            discountFormSubmitted && !rf.name.invalid
                        }"
                        required
                        #name
                      />
                      <div
                        *ngIf="
                          rf.name.touched &&
                          (rf.name.invalid ||
                            rf.name.errors?.required)
                        "
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> Name
                        is required
                      </div>
                    </fieldset>
                    <fieldset class="form-group">
                        <ng-select [items]="discountList" bindLabel="name" bindValue="name" [closeOnSelect]="false"
                        placeholder="Select Discount Type" [(ngModel)]="selectedDiscount" [ngModelOptions]="{standalone: true}"
                        (change)="getDiscountId($event)">
                      </ng-select>
                    </fieldset>
                    <fieldset class="form-group">
                        <label for="amount"> Amount</label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="amount"
                          id="amount"
                          placeholder="Enter amount"
                          [ngClass]="{
                            'is-invalid':
                              discountFormSubmitted && rf.amount.invalid,
                            'is-valid':
                              discountFormSubmitted && !rf.amount.invalid
                          }"
                          required
                          #amount
                        />
                        <div
                          *ngIf="
                            rf.amount.touched &&
                            (rf.amount.invalid ||
                              rf.amount.errors?.required)
                          "
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> amount
                          is required
                        </div>
                      </fieldset>
                  </form>
                </div>
                <div class="col-md-6">
                  <form [formGroup]="discountForm">
                    <fieldset class="form-group">
                        <label for="notes">Notes</label>
                        <textarea
                          formControlName="notes"
                          id="hidden-label-form-6"
                          rows="3"
                          class="form-control"
                          name="comment2"
                          placeholder="Enter notes"
                          [ngClass]="{
                            'is-invalid': discountFormSubmitted && rf.notes.invalid,
                            'is-valid': discountFormSubmitted && !rf.notes.invalid
                          }"
                          required
                          #notes
                        ></textarea>
                        <div
                          *ngIf="
                            rf.notes.touched &&
                            (rf.notes.invalid || rf.notes.errors?.required)
                          "
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> notes is
                          required
                        </div>
                      </fieldset>
                    <fieldset class="form-group">
                        <label for="admin_notes">Admin Notes</label>
                        <textarea
                          formControlName="admin_notes"
                          id="hidden-label-form-6"
                          rows="3"
                          class="form-control"
                          name="comment2"
                          placeholder="Enter admin notes"
                          [ngClass]="{
                            'is-invalid': discountFormSubmitted && rf.admin_notes.invalid,
                            'is-valid': discountFormSubmitted && !rf.admin_notes.invalid
                          }"
                          required
                          #admin_notes
                        ></textarea>
                        <div
                          *ngIf="
                            rf.admin_notes.touched &&
                            (rf.admin_notes.invalid || rf.admin_notes.errors?.required)
                          "
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> admin_notes is
                          required
                        </div>
                      </fieldset>
                    <div
                      class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                    >
                      <button
                        type="submit"
                        class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                        (click)="submitDiscount()"
                      >
                        Submit
                      </button>
                      <button
                        type="reset"
                        class="btn btn-secondary"
                        (click)="back()"
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  